var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaii = function SvgDaii(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    rx: 180,
    fill: "#FC5C01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 255V105H217.429V126.429H238.857V233.571H217.429V255H121ZM153.143 222.857H206.714V137.143H153.143V222.857Z",
    fill: "white"
  })));
};
export { SvgDaii as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYwIiBoZWlnaHQ9IjM2MCIgdmlld0JveD0iMCAwIDM2MCAzNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzNjAiIGhlaWdodD0iMzYwIiByeD0iMTgwIiBmaWxsPSIjRkM1QzAxIi8+CjxwYXRoIGQ9Ik0xMjEgMjU1VjEwNUgyMTcuNDI5VjEyNi40MjlIMjM4Ljg1N1YyMzMuNTcxSDIxNy40MjlWMjU1SDEyMVpNMTUzLjE0MyAyMjIuODU3SDIwNi43MTRWMTM3LjE0M0gxNTMuMTQzVjIyMi44NTdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";